import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
  GuideContrast,
} from "../GuideBlocks.js";

const StressReducesClaritySection = ({ heading, accentIndex = 2 }) => (
  <GuidePanel sectionId="stress-reduces-clarity" heading={heading} accentIndex={accentIndex}>
    <GuideLead>
      Stress changes how the brain processes information. When stressed, attention shifts into a
      reactive mode focused on identifying potential threats.
    </GuideLead>
    <GuideSectionLabel>What happens under stress</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="energy" title="Attention narrows" description="Focus locks onto perceived threats" />
      <GuideCard iconKey="stress" title="Past experiences dominate" description="Old patterns feel more influential" />
      <GuideCard iconKey="stress" title="Worst-case scenarios" description="Catastrophic thinking feels believable" />
      <GuideCard iconKey="energy" title="Emotion over logic" description="Reactions outweigh reasoning" />
    </GuideCardGrid>
    <GuideCallout>
      This explains why intelligent people sometimes make poor decisions during stressful periods.
    </GuideCallout>
    <GuideContrast
      items={[
        { title: "Stress does not reduce intelligence.", text: "Your capability is still there." },
        { title: "It reduces access to clear thinking.", text: "The path to clarity gets blocked." },
      ]}
    />
    <GuideCallout variant="amber">
      The first step toward mental clarity is recognizing when you are thinking in a reactive state.
    </GuideCallout>
  </GuidePanel>
);

export default StressReducesClaritySection;
